import axios from 'axios';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import API from '../endpoints';
import { PaginatedResponse, Club } from '@repo/types';
import { getAccessToken } from '../utils/getAccessToken';

const accessToken = getAccessToken();

// 30 minutes frontend cache for club list query
const CACHE_TIME = 30 * 60 * 1000;

type QueryOptions = {
  variables?: Partial<{
    name: string;
    page: number;
    limit: number;
    competitionId?: string;
    showEditableClubs?: boolean;
  }>;
  enabled?: boolean;
};

export const useClubsQuery = (options?: QueryOptions) => {
  const { variables, ...queryOptions } = options ?? {};
  return useQuery({
    queryKey: ['clubs', variables],
    queryFn: fetchClubs,
    staleTime: !accessToken ? CACHE_TIME : undefined,
    ...(queryOptions ?? {}),
  });
};

const fetchClubs: QueryFunction<PaginatedResponse<Club>, [string, QueryOptions['variables']]> = async ({
  queryKey,
}) => {
  const [, variables] = queryKey;
  const { data } = await axios.get<PaginatedResponse<Club>>(API.endpoints.clubs, {
    params: variables ?? {},
  });
  return data;
};
